export const openOverlay = (data) => {
    return {
        type: 'OMMIT_OVERLAY',
        payload: true,
        data: data
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/MultifolderView/components/User/components/Ommit/actions.js